import React, { Component } from 'react';
import { Map, Marker, Popup, TileLayer, withLeaflet } from 'react-leaflet'
import { ReactLeafletSearch } from 'react-leaflet-search'
import MarkerClusterGroup from 'react-leaflet-markercluster';

import Sidebar from '../Sidebar';
import moment from 'moment-with-locales-es6';
import { connect} from "remx";
import broker from '../../../utils/broker';
import config from '../../../utils/config';

import dataStore from '../../../stores/data';

const ReactLeafletSearchComponent = withLeaflet(ReactLeafletSearch);

class DataMap extends Component {
    constructor(props) {
        super(props);
    
    this.options = {

    }

    this.state = {
            reload:false,
            loading: false,
            id_pk_column: 'id',
            detail_kategori : {},
            data_pelanggan : [],
            drag_marker : false,
            show_graphic : false,
            download : false,
            url_report: '',
            lat: -7.257472,
            lng: 112.752088,
            zoom: 12,
            position : [-7.257472, 112.752088],
        }
    }


    componentDidMount(){
        var addScript = document.createElement('script');
        addScript.setAttribute('src', '/assets/js/dashforge.filemgr.js');
        document.body.appendChild(addScript);

        if (this.props.data_kategori_per.id_kategori) {
            this.getDataKategoriPer();
            this.getDataPelanggan();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.data_kategori_per !== prevProps.data_kategori_per){
            this.getDataPelanggan();
            this.getDataKategoriPer();
        }
    }

    getDataPelanggan(){
        broker.fetch.get(`data/kategori/${this.props.data_kategori_per.id_kategori}/pelanggan`)
        .then(res => {
            const { data } = res.data;
            if (data) {
                this.setState({data_pelanggan : data})
            } else {

            }
        }).catch(err => {
            
        });
    }

    getDataKategoriPer(){
        broker.fetch.get(`data/kategori/${this.props.data_kategori_per.id_kategori}`)
        .then(res => {
            const { data } = res.data;
            if (data) {
                this.setState({detail_kategori : data})
            } else {

            }
        }).catch(err => {
            
        });
    }

    generateContent(){
        var content = this.state.detail_kategori;
        let return_content = [];
        if (content) {
            for (var key in content){
                if(!key.includes('id') && !key.includes('created_at') && !key.includes('updated_at'))
                    return_content.push(<React.Fragment key={key}>
                                            <label className="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase" key={key}>{key.replace("_", " ")}</label>
                                            <p className="tx-13 mg-b-10">{content[key]}</p>
                                        </React.Fragment>);
    
            }
        }

        return return_content;
    }

    render(){
        return(
            <div className="contact-wrapper">
                <Sidebar />
                <div className="filemgr-content">
                    <div className="chat-content-header" style={{marginTop: '-5px'}}>
                        <div>
                            <h6 id="channelTitle" className="mg-b-0">#MapPeekerjaan</h6>
                        </div>  
                    </div>
                    <div className="filemgr-content-body" style={{backgroundColor: 'white', marginRight: '288px'}}>
                        <Map center={this.state.position} zoom={this.state.zoom} maxZoom={19} style={{height:"100%", maxWidth: '100%'}} onClick={this.handleClick}>
                            <ReactLeafletSearchComponent
                                position="topleft"
                                provider="OpenStreetMap"
                                providerOptions={{region: 'id'}}
                                showMarker={true}
                                showPopup={true}
                                // closeResultsOnClick={true} 
                                zoom={15}
                                popUp={ this.myPopup }
                            />
                            <TileLayer
                            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <MarkerClusterGroup>
                                {(this.state.data_pelanggan) &&
                                        this.state.data_pelanggan.map((data, i) => {
                                            if (data.latitude){
                                                return  <Marker key={i} position={[data.latitude, data.longitude]}>
                                                            <Popup key={i}>
                                                                {data.nama_pelanggan} <br /> {data.alamat_pemasangan} <br /> {data.alamat_ip}
                                                            </Popup>
                                                        </Marker>
                                            }

                                        })
                                }
                            </MarkerClusterGroup>
                        </Map>
                    </div>
                    <div className="contact-content-sidebar">
                        <label className="nav-label tx-color-03">Detail Data</label>
                        <hr className="mg-t-0"></hr>
                        {(this.state.detail_kategori) &&
                            this.generateContent()
                        }
                       
                    </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps(props) {
    return {
        pelanggan_id : dataStore.getters.getDataPelangganId(),
        type_view : dataStore.getters.getDataTypeView(),
        year_view : dataStore.getters.getDataYearView(),
        month_view : dataStore.getters.getDataMonthView(),
        date_view : dataStore.getters.getDataDateView(),
        form_view : dataStore.getters.getDataFormView(),
        lat_lng : dataStore.getters.getLatLon(),
        data_pelanggan : dataStore.getters.getDataPelanggan(),
        data_kategori : dataStore.getters.getDataKategori(),
        data_kategori_per : dataStore.getters.getDataKategoriPer(),
    }
}


export default connect(mapStateToProps)(DataMap);
